angular.module('ui2.0Controllers').controller('createDelegationController', ['$scope', '$uibModal', '$rootScope', '$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', '$document', '$route', '$filter', '$q','showPageService', function ($scope, $modal, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, $document, $route, $filter, $q,$showPageService) {
    $scope.globalData = {dateFormatToShow :  SirionUtils.getDateFormat()}
    SirionUtils.setUpCommonPicker.call($scope, 'effectiveDelegationStartDate', "", false, false);
    SirionUtils.setUpCommonPicker.call($scope, 'effectiveDelegationEndDate', "", false, false);

    $scope.getMSSettings = function (singleSelect) {
        if(singleSelect) {
            $scope.mssettings.showCheckAll = false;
            $scope.mssettings.selectionLimit = 1;
        } else {
            $scope.mssettings.showCheckAll = true;
            delete $scope.mssettings.selectionLimit;
        }
        return $scope.mssettings;
    };
    let userData = JSON.parse(localStorage.getItem('sideLayoutData'))?.data?.headerBar?.userData;

    $scope.userFrom = {
        name : userData.userName,
        id : userData.userId
    }

    $scope.initForm = () =>{
        let url = addtStamp(apiVersioning.getApiDynamicVersion("delegation_createForm", $rootScope.isDelegationAdminEnabled ? $scope.userFrom?.id : null));

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: "application/json",
            dataType: "json",
            url: url,
            success: function (response, status) {
                $scope.dataAdditionalFields = Object.create(response);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error(textStatus + ': ' + errorThrown);
            }
        });
    }
    $scope.initForm();
    
    //Options to choose allEntities or by-each Entity
    $scope.allTasks = true;
    //Assign To Field
    $scope.usersPostData = {};

    $scope.acURL = '/options/3?pageType=1&entityTpeId=20&parentEntityId=&pageEntityTypeId=314&fieldId=&expandAutoComplete=true'
    //For auto Complete URL input Filed for users
    $scope.fieldLayoutData = {
        "createDelegationUsers": SirionUtils.createAutoSelectFieldLayout({id:12030,name: "UsersCreateDelegation", label: "user",type: "select"}),
    };
    //entityType
    $scope.selectedEntityType =[];
    //contracts
    $scope.contractOptions = [];
    $scope.selectedContracts = [];
    //supplier
    $scope.supplierOptions = [];
    $scope.selectedSupplier = [];
    //rollGroups
    $scope.selectedRollGroups = [];
    $scope.updateForm = (selectionObj) =>{
        if(selectionObj?.prevSelectedObj?.id != selectionObj?.finalObj?.id){
            $scope.allTasks = true;
            $scope.usersPostData = {};
            $scope.selectedContracts = [];
            $scope.selectedSupplier = [];
            $scope.selectedRollGroups = [];
            $scope.selectedEntityType = [];
            if(!_.isEmpty($scope.userFrom))
                $scope.initForm();
        }
    }
    $scope.userFromMsEvents = {
        'onSelectionChanged': $scope.updateForm
    };

    //to open confirmAlertBox on click of cancel
    $scope.cancelCreateDele = function(){
        const args = {
            popupType: 'confirm',
            str: intl_msg[23574],
            heading: intl_msg[25772],
            yesCbFn: function () {
                $scope.createDelegationModalInstance.close()
            },
            noCbFn: function () {
                return false;
            }
        }
        SirionUtils.openSirionDialogs(args);
    }
    //----------------------- ends here -----------

    //flag to toggle error messages post API-Call
    $scope.showErrorMsgPostApiCall = false;
   //-----------Post Selected Data to make create Delegation Request------------------
    $scope.createDelegationReq = function(){
            //function to get Start and end Date
            var startDateFormatted = moment($scope.startDate ? $scope.startDate: null,SirionUtils.getDBDateFormat()).format(SirionUtils.getDBDateFormat());
            var endDateFormatted = moment($scope.endDate ? $scope.endDate: null,SirionUtils.getDBDateFormat()).format(SirionUtils.getDBDateFormat());

            var selectedEntityTypeCopy = angular.copy($scope.selectedEntityType);
            angular.forEach(selectedEntityTypeCopy, function (data) {
                data.$$hashKey ? delete data.$$hashKey : "";
            });

            var selectedContractsCopy = angular.copy($scope.selectedContracts);
            angular.forEach(selectedContractsCopy, function (data) {
                data.$$hashKey ? delete data.$$hashKey : "";
                data.group ? delete data.group : "";
                data.parentIds ? delete data.parentIds : "";
                data.parentName ? delete data.parentName : "";
            });

            var selectedSupplierCopy = angular.copy($scope.selectedSupplier);
            angular.forEach(selectedSupplierCopy, function (data) {
                data.$$hashKey ? delete data.$$hashKey : "";
            });

            var selectedRollGroupsCopy = angular.copy($scope.selectedRollGroups);
            angular.forEach(selectedRollGroupsCopy, function (data) {
                data.$$hashKey ? delete data.$$hashKey : "";
                data.parentName ? delete data.parentName : "";
            });

            if($scope.usersPostData.values){
                var usersCopy = angular.copy($scope.usersPostData.values);
                usersCopy.idType ? delete usersCopy.idType : "";
                usersCopy.properties ? delete usersCopy.properties : "";
                delete usersCopy.userGroup;
                console.log(usersCopy.properties);
            }

            // post-object to make delegation request
            var postObj = {
                "startDate": startDateFormatted,
                "endDate": endDateFormatted,
                "toUser": $scope.usersPostData
            }
            if($rootScope.isDelegationAdminEnabled ){
                postObj.fromUser = $scope.userFrom;
            }
            if(!$scope.allTasks){
                if($scope.selectedEntityType.length)
                    postObj.entityTypes = selectedEntityTypeCopy;
                if($scope.selectedRollGroups.length)
                    postObj.roleGroups = selectedRollGroupsCopy;
                if($scope.selectedContracts.length)
                    postObj.contracts = selectedContractsCopy;
                if($scope.selectedSupplier.length)
                    postObj.suppliers = selectedSupplierCopy
            }
            if(($rootScope.isDelegationAdminEnabled && !$scope.userFrom.id) || !$scope.usersPostData.id || startDateFormatted == "Invalid date" || endDateFormatted == "Invalid date"){
                return;
            }
            if((!$scope.allTasks) && !$scope.selectedEntityType.length){
                $scope.errorMsgEntityType =  intl_msg[4885] ;
                $scope.errorMsgEntityTypeFlag = true ;
                return;
            }
            if($rootScope.isDelegationAdminEnabled && $scope.userFrom?.id == $scope.usersPostData?.id){
                Toaster.create(intl_msg[35708] || 'From and To user can not be same');
                return;
            }
            startLoader();

            $.ajax({
            type:"POST",
            dataType: "json",
            cache: false,
            contentType: "application/json;charset=UTF-8",
            data: JSON.stringify(postObj),
            url:  "/delegation/create",
            success: function (response, status) {
                if(response.status==="applicationError"){
                    $scope.showErrorMsgPostApiCall = true;
                    $scope.errorMsgPostAPI = response.errorMessage;
                    $scope.$apply();
                }
                else{
                    $timeout(()=>{
                        $rootScope.$emit("refreshLeftPanel");
                        $scope.createDelegationModalInstance.close()
                    },100)
                }
                stopLoader();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error(textStatus + ': ' + errorThrown);
                stopLoader();
            }
        });
        /* if($scope.usersPostData && $scope.startDate && $scope.endDate ){
         }*/
    }

    $scope.handleDateChange = function(){
        $scope.showErrorMsgPostApiCall = false;
    }

    //--------------Create Del request Ends here-------------------------
    $scope.isAdditionalFieldVisible = false;
    $scope.toggleAdditionalFields = function(){
        $scope.isAdditionalFieldVisible = !$scope.isAdditionalFieldVisible
    }
    $scope.openCalendarPopup = function (e, which, calculatePos) {
        e.preventDefault();
        var calPromise = new Promise(function (res, rej) {
            e.stopPropagation();
            /*if ($scope.commonDatepicker.opened[which] == true) {
                $scope.datepicker.opened[which] = false;
            } else {
                $scope.commonDatepicker.opened[which] = true;
                $scope.$broadcast('closeMsDD');
            }*/
            if($scope.commonDatepicker.opened[which] == true){
                $scope.commonDatepicker.opened = {};
            }else{
                $scope.commonDatepicker.opened = {};
                $scope.commonDatepicker.opened[which] = true;
                $scope.$broadcast('closeMsDD');

            }
            var resObj = {'evt': e, 'calPos': calculatePos}
            res(resObj);
        });
        calPromise.then(function (resObj) {
            if (resObj.calPos) {
                showPageService.setPositionOfDatepicker(resObj.evt.target);
            }
        });
    };

    $scope.getSelectEntityIds = () =>{
        if($scope.selectedEntityType?.length){
            const entityTypeIds = $scope.selectedEntityType.map(item => item.id);
            return entityTypeIds
        } 
    }
   
}]);
